module.exports = __webpack_public_path__ + "img/h5_banner01.bbdfcb09.webp";